import React, { Component } from "react";
import { css } from "react-emotion";
import styled from "react-emotion";
import { withRedux } from "helpers";
import { flexColumn, Button } from "appStyles";

const container = css`
  ${flexColumn}
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  overflow-y: scroll;
  padding: 15px;
  * {
    margin-bottom: 5px;
  }
  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

const pointsText = css`
  font-size: 15px;
  height: auto;
`;
const smallText = css`
  font-size: 9px;
  height: auto;
`;

const redeemButton = css`
  border-radius: 30px;
  padding: 10px;
  margin: auto;
  border: 1px solid black;
  font-size: 0.6em;
`;

const redeemButtonBig = css`
  border-radius: 25px;
  border: 1px solid black;
  color: black;
  font-size: 12px;
  padding: 10px;
  width: 200px;
  margin: 20px auto !important;
`;

const finePrintStyle = css`
  font-size: 9px;
  word-wrap: break-word;
  text-decoration: underline;
`;

const Reward = styled("div")`
  color: black;
  width: 100%;
  margin: 5 0 10 0;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  background: ${(props) => (props.isHeader ? "#e7e7e7" : "white")};
  padding-top: 10px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background: #e7e7e7;
    transform: scale(1.02);
  }

  border: ${(props) => "1px solid " + props.color};
`;

const spaceBetween = css`
  display: flex;
  justify-content: space-between;
  position: relative;
`;

const underline = css`
  text-decoration: underline;
`;

const spaceAround = css`
  display: flex;
  justify-content: space-around;
`;

const midLine = css`
  border-left: 1px solid white;
  height: 4em;
`;

const ProgressBar = styled("div")`
  background-color: grey;
  width: 80%;
  margin: auto;

  div {
    background-color: #009dff;
    height: 2px;
    width: ${(props) => `${props.progress}%`};
  }
`;

const progressBarPercent = (numerator, denominator) => {
  const percent = (numerator / denominator) * 100;
  return percent > 100 ? 100 : percent;
};

class Rewards extends Component {
  state = {
    showFinePrintIdx: null,
  };

  onClick = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;

    updateActiveEditor(idx);
  };

  showFinePrint = (rewardIdx) => {
    this.setState({ showFinePrintIdx: rewardIdx });
  };

  closeFinePrint = () => {
    this.setState({ showFinePrintIdx: null });
  };

  componentWillUnmount() {
    let { activeEditor } = this.props;

    if (activeEditor) {
      this.props.actions.refreshActiveEditor();
    }
  }

  render() {
    const { activeEditor, activeApp, rewards } = this.props;
    const { name, dollarsToDollarCashCreditConversion } = activeApp;
    const defaultPoints = 100;
    const defaultCash = (dollarsToDollarCashCreditConversion
      ? defaultPoints / dollarsToDollarCashCreditConversion / 100
      : 0
    ).toFixed(2);
    const sortedIds = [];
    Object.keys(rewards).forEach((id) => {
      const deal = rewards[id];
      if (deal.retired) {
        sortedIds.push(id);
      } else {
        sortedIds.unshift(id);
      }
    });

    if (!rewards) return null;

    return (
      <div className={container}>
        <Reward
          background="#89d2d3"
          isHeader={true}
          style={{ marginBottom: "10px" }}
          color={this.props.activeApp.view.navigation.navBarColor}
        >
          <h2>{name}</h2>
          <div className={spaceAround}>
            <div>
              <p style={{ fontSize: "20px" }}>
                {defaultPoints.toLocaleString()}
              </p>
              <p style={{ fontSize: "12px" }}>Points</p>
              <p className={redeemButton}>EARN POINTS</p>
            </div>
            <div className={midLine} />
            <div>
              <p style={{ fontSize: "20px" }}>${defaultCash}</p>
              <p style={{ fontSize: "12px" }}>Cash Credit</p>
              <p className={redeemButton}>USE CASH CREDIT</p>
            </div>
          </div>
        </Reward>

        {rewards &&
          sortedIds.map((id) => {
            const reward = rewards[id];
            let {
              item,
              expiration,
              maxUses,
              pointsForItem,
              finePrint,
              retired,
            } = reward;

            const border = activeEditor == id ? "2px solid red" : null;
            const parsedExpiration = new Date(expiration).toLocaleDateString(
              "en-US"
            );
            if (reward.retired != 1)
              return (
                <Reward
                  border={border}
                  key={id}
                  color={this.props.activeApp.view.navigation.navBarColor}
                  onMouseLeave={this.closeFinePrint}
                  onClick={() => this.onClick(id)}
                >
                  <h2>{item}</h2>
                  {pointsForItem ? (
                    <p className={pointsText}>
                      {pointsForItem.toLocaleString()} Points
                    </p>
                  ) : null}

                  {/* <ProgressBar
                  progress={progressBarPercent(defaultPoints, pointsForItem)}
                >
                  <div></div>
                </ProgressBar> */}
                  <p className={redeemButtonBig}>REDEEM </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        (maxUses && !finePrint) || (expiration && !finePrint)
                          ? "start"
                          : "space-between",
                      padding: "0px 10px",
                    }}
                  >
                    {maxUses && expiration ? (
                      <p className={smallText}>
                        Expires: {parsedExpiration} | Uses Remaining: {maxUses}
                      </p>
                    ) : null}
                    {!maxUses && expiration ? (
                      <p className={smallText}>Expires: {parsedExpiration}</p>
                    ) : null}
                    {maxUses && !expiration ? (
                      <p className={smallText}>Uses Remaining: {maxUses}</p>
                    ) : (
                      <p className={smallText}></p>
                    )}
                    {finePrint ? (
                      <p className={finePrintStyle}>Fine Print</p>
                    ) : (
                      <p className={finePrintStyle}></p>
                    )}
                  </div>
                </Reward>
              );
          })}
      </div>
    );
  }
}

export default withRedux(Rewards);
